module.exports = __webpack_public_path__ + "media/images/birthday/birthday-template-ro-b423d4e540e3c6c8e517d5a966e00746.png";